<template>
  <div class="container page victoria-record-page recharge-record-page">
    <van-nav-bar title="Deposit history" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="No more data"
        @load="onLoad"
      >
        <div class="record-item" v-for="(item, index) in list" :key="index">
          <div class="record-header">
            <span class="status" :class="item.status === 1 ? 'status-paid' : 'status-pending'">{{ item.status === 1 ? 'Paid' : 'Pending' }}</span>
            <span class="amount" :class="item.money > 0 ? 'amount-positive' : 'amount-negative'">Amount: {{ item.money }}</span>
          </div>
          <div class="record-info">
            <p class="info-label">Illustration:</p>
            <p class="info-text" v-if="item.desc">{{ item.desc }}</p>
          </div>
          <div class="record-time">
            <p><span>Submission time</span>: {{ item.create_time }}</p>
            <p><span>Review time</span>: {{ item.update_time }}</p>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onLoad() {
      this.getMoneyLog();
    },
    getMoneyLog() {
      this.$http({
        method: 'get',
        url: 'getMoneylog',
        params: {
          page: this.page
        }
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.loading = false;
        this.finished = true;
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
  font-size: 0.48rem;
}

.main-content {
  padding: 0.26667rem;
}

.record-item {
  background: #fff;
  border-radius: 0.2rem;
  padding: 0.4rem;
  margin-bottom: 0.26667rem;
  box-shadow: 0 0 1.067vw 0 #e4e4e7;
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
}

.status {
  font-size: 0.42667rem;
  font-weight: bold;
}

.status-paid {
  color: #00c853;
}

.status-pending {
  color: #ff9800;
}

.amount {
  font-size: 0.42667rem;
  font-weight: bold;
}

.amount-positive {
  color: #e74c3c;
}

.amount-negative {
  color: #e74c3c;
}

.container p{
  padding: 0 !important;
}

.info-label {
  font-size: 0.32rem;
  color: #999;
  margin: 0 0 0.1rem 0;
}

.info-text {
  font-size: 0.37333rem;
  color: #333;
  margin: 0;
}

.record-time {
  border-top: 0.02667rem solid #f5f5f5;
}

.record-time p {
  font-size: 0.32rem;
  color: #000;
  margin: 0.1rem 0;
  padding: 0.1rem 0;
}

::v-deep .van-list__finished-text {
  font-size: 0.32rem;
  color: #999;
}
</style>
